Drupal.behaviors.articleShare = {
    attach() {
        const title = document.title;
        const url = window.location.href;
        const btns = document.querySelectorAll('.system-share');

        const shareData = {
            // title: title, // title is not used on all devices
            text: title,
            url: url
        }

        btns.forEach(function (btn) {
            if (navigator.share) {
                btn.addEventListener('click', async () => {
                    navigator.share(shareData).then(() => {
                        console.debug('shared', shareData);
                    }).catch(console.error);
                });
            } else {
                btn.style.display = 'none';
                console.debug('Warning: Web Share API not supported.');
            }
        })  
    },
};